export default "__VITE_ASSET__BtaHNQZe__"